import React from 'react';
import { observer } from 'mobx-react-lite';

import PageHeading from 'src/components/common/page-heading';
import Catalog from './components/catalog';
import OrderTotal from './components/order-total';

import globalStore from 'src/stores/global-store';

import { IS_HEBREW, LOCALES } from 'src/constants';

const MainPage = observer(() => {
  const { decedent, isNoSlug } = globalStore;
  const title = isNoSlug && IS_HEBREW ? LOCALES.RESTORATION_TOMBSTONE : LOCALES.AFTERCARE_SERVICES;
  const description = isNoSlug && IS_HEBREW ? LOCALES.AFTERCARE_SERVICES : undefined;

  return (
    <>
      <PageHeading decedent={decedent} step={1} title={title} description={description} />
      <Catalog />
      <OrderTotal />
    </>
  );
});

export default MainPage;
